import axios from "axios";
import { BidAuth, BidCollect, BankIdData, BidStatus, BidHintCode } from "../types/bankId";
import { REACT_APP_API_URI, REACT_APP_AUTH_URI, REACT_APP_DB_NAME, REACT_APP_NODEJOBAPI_URI, REACT_APP_PYJOBAPI_URI } from "../env";

export const setCookieOnServices = async (token: string) => {
    const config = {
        withCredentials: true,
        headers: {
            Accept: "application/json; charset=utf-8",
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`
        }
    };

    const requests: Promise<any>[] = [];

    if (REACT_APP_DB_NAME === "prod") {
        requests.push(
            axios.post(REACT_APP_NODEJOBAPI_URI + "/set", {}, config).catch(console.error),
            axios.post(REACT_APP_PYJOBAPI_URI + "/set", {}, config).catch(console.error)
        );
    }

    requests.push(axios.post(REACT_APP_API_URI + "/set", {}, config).catch(console.error));

    await Promise.all(requests); // ✅ wait for all requests to finish
};

export const initiateBankIdAuth = async (): Promise<BidAuth | null> => {
    try {
        const response = await axios.get<BidAuth>(`${REACT_APP_AUTH_URI}/bid_auth`, {
            headers: {
                Accept: "application/json; charset=utf-8",
                "Content-Type": "application/json"
            },
            withCredentials: true
        });

        return response.data.orderRef ? response.data : null;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const collectBankIdAuth = async (orderRef: string): Promise<BidCollect | null> => {
    try {
        const response = await axios.get<BidCollect>(`${REACT_APP_AUTH_URI}/bid_auth/${orderRef}`, {
            headers: {
                Accept: "application/json; charset=utf-8",
                "Content-Type": "application/json"
            },
            withCredentials: true
        });

        return response.data || null;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const passwordLogin = async (personalNumber: string, password: string) => {
    const form = new URLSearchParams({
        username: personalNumber,
        client_id: REACT_APP_DB_NAME,
        grant_type: "password",
        password
    });

    return axios.post(`${REACT_APP_AUTH_URI}/token`, form, {
        headers: {
            Accept: "application/json; charset=utf-8",
            "Content-Type": "application/x-www-form-urlencoded"
        },
        withCredentials: true
    });
};

export const createInitialBankIdData = (): BankIdData => {
    const orderRef = localStorage.getItem("orderRef");
    return {
        autoStartToken: "",
        qrStartToken: "",
        orderRef: orderRef || "",
        status: orderRef ? BidStatus.pending : BidStatus.start,
        hintCode: BidHintCode.outstandingTransaction,
        qrCode: ""
    };
};

export const resetBankIdData = (): BankIdData => ({
    autoStartToken: "",
    qrStartToken: "",
    orderRef: "",
    status: BidStatus.start,
    hintCode: BidHintCode.outstandingTransaction,
    qrCode: ""
});
